import styled from '@emotion/styled';
import { fonts } from '@theme/fontsCustomer';

export const DateText = styled('p')`
  ${fonts.Body2};
  color: ${({ theme }) => theme.colors['text-gray-sub-dark']};
`;
